export const Actions = {
  VIEW: 'view',
  EDIT: 'edit',
  CREATE: 'create',
  DELETE: 'delete',
  TOGGLE_ACTIVATION: 'toggleActivation',
  ADJUST_BALANCE: 'adjustBalance',
  VIEW_PAYMENT_CARDS: 'viewPaymentCards',
  DELETE_PAYMENT_CARD: 'deletePaymentCard',
  DOWNLOAD: 'download',
  REFUND: 'refund',
  REVERSE: 'reverse',
  INVITE: 'invite',
  ADD: 'add',
  INITIATE_CONNECTION: 'initiateConnection',
  VIEW_ONGOING_SESSIONS: 'viewOngoingSessions',
  EDIT_EMAIL: 'editEmail',
  VIEW_NOTIFICATIONS: 'viewNotifications',
}

export const Subjects = {
  USERS: 'Users',
  TRANSACTIONS: 'Transactions',
  ADMINS: 'Admins',
  ROLES: 'Roles',
  POINTS: 'Points',
  VOUCHERS: 'Vouchers',
  NOTIFICATIONS: 'Notifications',
  NOTIFICATION_GROUPS: 'NotificationGroups',
  DASHBOARD: 'Dashboard',
  ADMIN_ACTIONS: 'AdminActions',
  COUNTRIES: 'Countries',
  CHARGING_TOKENS: 'ChargingTokens',
  CHARGING_TOKENS_DESIGN: 'ChargingTokensDesign',
  OCPI_INTEGRATION: 'OcpiIntegration',
  ONGOING_SESSIONS: 'OngoingSessions',
  INVOICES: 'Invoices',
  CORPORATE_SUBSCRIPTIONS: 'CorporateSubscriptions',
  CORPORATES: 'Corporates',
}
